/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Carsten Bühler
 * Date: 12.02.2016
 *
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';

import { Col, Container, Form, FormControl, FormLabel, Row } from 'external/react-bootstrap';
import { Title, translation } from 'plugin/liferay-widgets-react-web';
import { FliwasFormGroup } from '../components/BasicFormComponents';

let optionsMinSec = [], optionsHours = [];
for (let i = 0 ; i < 60 ; i++) {
    optionsMinSec.push(<option key={i} value={i}>{i}</option>);
    if (i < 24) {
        optionsHours.push(<option key={i} value={i}>{i}</option>);
    }
}

class WebCamWidgetConfigForm extends React.Component {

    constructor(props){
        super(props);
        const { refreshInterval } = props.formData;

        this.state = {
            seconds: refreshInterval ? (refreshInterval % 3600) % 60 : 0,
            minutes: refreshInterval ? parseInt((refreshInterval % 3600) / 60, 10) : 1,
            hours: refreshInterval ? parseInt(refreshInterval / 3600, 10) : 0
        };

        this.change({
            refreshInterval: refreshInterval || 60 // initial refresh interval
        });
    }

    onChangeImageUrl(e){
        this.change({ imageUrl: e.target.value });
    }

    onChangePassword(e){
        this.change({ password: e.target.value });
    }

    onChangeUsername(e){
        this.change({ username: e.target.value });
    }

    onChangeRefreshInterval(unit, e){
        const { seconds, minutes, hours } = this.state;
        const val = parseInt(e.target.value);
        let refreshInterval;
        this.setState({
            [unit]: val
        });

        switch (unit) {
            case 'seconds':
                refreshInterval = val + minutes * 60 + hours * 60 * 60;
                break;
            case 'minutes':
                refreshInterval = seconds + val * 60 + hours * 60 * 60;
                break;
            case 'hours':
                refreshInterval = seconds + minutes * 60 + val * 60 * 60;
                break;
        }

        this.change({
            refreshInterval: refreshInterval
        });
    }

    change(o){
        const formData = { ...this.props.formData, ...o };
        this.props.onChange(formData, this.validate(formData));
    }

    validate(formData){
        let imageUrlValid, refreshIntervalValid, usernameValid, passwordValid;

        if (!(formData.imageUrl && formData.imageUrl.length > 0)) {
            imageUrlValid = 'Bitte URL eingeben';
        }

        if ((formData.imageUrl && formData.imageUrl.length > 0)) {
            if (formData.imageUrl === 'Sid' || formData.imageUrl === '/base-portlet/images/SID.jpg') {
                formData.imageUrl = '/base-portlet/images/SID.jpg';
            }
            // eslint-disable-next-line no-useless-escape
            else if ((!(/^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(formData.imageUrl)))) {
                imageUrlValid = 'Bitte gültige URL eingeben!';
            }
        }

        if (!(formData.refreshInterval && formData.refreshInterval >= 60)) {
            refreshIntervalValid = 'Aktualisierungsinterval muss mindestens 1 Minute betragen!';
        }

        if ((formData.username && formData.username.length > 0 && formData.username.length > 75)) {
            usernameValid = 'Benutzername darf nicht länger als 75 Zeichen sein!';
        }

        if ((formData.password && formData.password.length > 0 && formData.password.length > 75)) {
            passwordValid = 'Passwort darf nicht länger als 75 Zeichen sein!';
        }

        return {
            imageUrl: imageUrlValid,
            refreshInterval: refreshIntervalValid,
            username: usernameValid,
            password: passwordValid
        };
    }

    render(){
        const { seconds, minutes, hours } = this.state;
        let { formData, formValidation } = this.props;

        return (
            <fieldset>
                <Title title={translation.trans('image-widget-config-form-legend')}/>
                <Container>
                    <Row>
                        <Col xs={12}>
                            <FliwasFormGroup title={translation.trans('url')}
                                             formValidation={formValidation}
                                             propName={'imageUrl'}
                                             required>
                                <FormControl type="text"
                                             required
                                             value={formData.imageUrl}
                                             onChange={this.onChangeImageUrl.bind(this)}
                                             placeholder="http://www.abc.de/exampleImage.jpg"/>
                            </FliwasFormGroup>
                        </Col>
                        <Col xs={12}>
                            <FliwasFormGroup title={translation.trans('user')}
                                             formValidation={formValidation}
                                             propName={'user'}>
                                <FormControl type="text"
                                             value={formData.username}
                                             onChange={this.onChangeUsername.bind(this)}
                                             placeholder="Benutzer"/>
                            </FliwasFormGroup>
                        </Col>
                        <Col xs={12}>
                            <FliwasFormGroup title={translation.trans('password')}
                                             formValidation={formValidation}
                                             propName={'user'}>
                                <FormControl type="password"
                                             value={formData.password}
                                             onChange={this.onChangePassword.bind(this)}
                                             placeholder="Passwort"/>
                            </FliwasFormGroup>
                        </Col>
                        <Col xs={12}>
                            <FormLabel>
                                {translation.trans('refresh-interval')}
                            </FormLabel>
                            <Form inline>
                                <FliwasFormGroup
                                    title={translation.trans('hours')}
                                    formValidation={formValidation}
                                    propName={'refreshInterval'}
                                    required
                                >
                                    <FormControl
                                        className="mx-2"
                                        as="select"
                                        required
                                        value={hours}
                                        onChange={this.onChangeRefreshInterval.bind(this, 'hours')}
                                    >
                                        {optionsHours}
                                    </FormControl>
                                </FliwasFormGroup>

                                <FliwasFormGroup
                                    title={translation.trans('minutes')}
                                    formValidation={formValidation}
                                    required
                                >
                                    <FormControl
                                        className="mx-2"
                                        as="select"
                                        required
                                        value={minutes}
                                        onChange={this.onChangeRefreshInterval.bind(this, 'minutes')}
                                    >
                                        {optionsMinSec}
                                    </FormControl>
                                </FliwasFormGroup>

                                <FliwasFormGroup
                                    title={translation.trans('seconds')}
                                    formValidation={formValidation}
                                    required
                                >
                                    <FormControl
                                        className="mx-2"
                                        as="select"
                                        required
                                        value={seconds}
                                        onChange={this.onChangeRefreshInterval.bind(this, 'seconds')}
                                    >
                                        {optionsMinSec}
                                    </FormControl>
                                </FliwasFormGroup>
                            </Form>

                        </Col>
                    </Row>
                </Container>
            </fieldset>);
    }
}

WebCamWidgetConfigForm.propTypes = {
    onChange: PropTypes.func,
    formData: PropTypes.object,
    formValidation: PropTypes.object
};

export default WebCamWidgetConfigForm;




// WEBPACK FOOTER //
// ./js/widgets/WebCamWidgetConfigForm.jsx